<template>
  <div :class="classes()">
    <div :class="`${el}__head`" @click="toggle">
      <Headline v-if="likeWidget" :staticClass="`${el}__headline`" :headine="3" size="xs">
        {{ title }}
      </Headline>
      <Copy v-else element="div" size="l" color="primaryBlue" bold>
        {{ title }}
      </Copy>
      <Icon name="arrow-down-s-line" color="primaryBlueLight" size="xl" :class="`${el}__icon`" />
    </div>

    <div :class="`${el}__content`" ref="content" :style="{ maxHeight: `${height * 1.2}px` }">
      <div :class="`${el}__contentInner`">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/objects/Icon';
import Copy from '@/objects/Copy';
import Headline from '@/objects/Headline';

export default {
  name: 'Collapsible',
  components: {
    Icon,
    Copy,
    Headline,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    likeWidget: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      open: this.isOpen,
      scrollHeight: 0,
      height: this.isOpen ? 10000 : 0, // 10000 to prevent start animation
      el: 'c-collapsible',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--open`]: this.open,
          [`${el}--likeWidget`]: this.likeWidget,
        };
      },
    };
  },
  mounted() {
    this.setHeights();

    window.addEventListener('resize', this.setHeights);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setHeights);
  },
  methods: {
    setHeights() {
      if (this.$refs.content?.scrollHeight !== this.scrollHeight) {
        this.scrollHeight = this.$refs.content?.scrollHeight || 0;
        if (this.height > 0 || this.collapsibleIsOpen) {
          this.height = this.scrollHeight;
        }
      }
    },

    toggle() {
      this.height = this.height === 0 ? this.scrollHeight : 0;
      this.open = !this.open;
      if (this.open) {
        this.$emit('onTrackingClickOpen', this.title);
      }
    },
  },
};
</script>
